import { TooltipProvider } from "@/components/ui/tooltip";
import { CanvasFloatingToolbarFrame } from "../components/toolbar";
import { NodeToolbarContextMenuButton } from "./shared/NodeToolbarContextMenuButton";

interface WidgetFloatingToolbarProps {
  nodeId: string;
}

export function WidgetFloatingToolbar({ nodeId }: WidgetFloatingToolbarProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <CanvasFloatingToolbarFrame
        onMouseDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <NodeToolbarContextMenuButton nodeId={nodeId} />
      </CanvasFloatingToolbarFrame>
    </TooltipProvider>
  );
}
